module.exports = __webpack_public_path__ + "media/images/icon__arrow-left--rb-gray@2x-9370a3faeb7a387d682974fef0faa02a.png";